import { ReactNode } from "react";
import { RadioButton } from "../../forms";
import { radioButtonWrapper } from "./filterRadioButton.css";

const FilterRadioButton = ({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) => {
  return (
    <div className={radioButtonWrapper}>
      <RadioButton
        value={value}
        fontWeight="bold"
        radioIconPosition={"insetInlineEnd"}
      >
        {children}
      </RadioButton>
    </div>
  );
};

export default FilterRadioButton;
